import React, { Component } from "react";
import { Redirect } from "react-router-dom";

import API from "../../apiService.js";
import ALERT, { confirmedAlert } from "../component/Alert";
import Modal from "../form/ModalRujukan";
import "react-datepicker/dist/react-datepicker.css";
import PrintRunjukan from "../form/PrintRujukan";
import Autocomplete from "react-autocomplete";
import moment from "moment";
import ModalInternal from "../form/ModalRujukanInternal";
import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import PrintModal from "../form/PrintModal";
import BlobPrint from "view/component/BlobPrint.js";
import print from "print-js";
import Sisroute from "view/sisroute/Sisroute.js";
import { getBase64 } from "view/component/helper/helper.js";

const SignupSchema = Yup.object().shape({
  icd: Yup.string().required("ICD HARUS DIISI"),
});
export class Planning extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visit_id: props.patient.id,
      refSigna: [],
      advice: {
        id: props.patient.advice ? props.patient.advice.advice : "",
        visit_id: props.patient.id,
        advice: props.patient.advice ? props.patient.advice.advice : "",
        evaluation: props.patient.advice ? props.patient.advice.evaluation : "",
      },
      examFinish: false,
      ref_continue: [],
      continue_id: props.patient.continue_id ? props.patient.continue_id : "1",
      modalShow: false,
      modalInternal: false,
      modalPrint: false,
      date: moment(new Date()).format("YYYY-MM-DD"),
      drugsData: [],
      refSigna: [],
      drugs: [
        {
          visit_id: "",
          visit_inpatient_detail_id: 0,
          combination_name: "",
          combination_qty: 0,
          signa_id: 1,
          name: "",
          log: 0,
          note: "",
          details: [
            {
              drug_in_detail_id: null,
              qty: "",
              drug: {
                id: "",
                name: "",
              },
              drug_id: "",
            },
          ],
        },
      ],

      drugsMix: [
        {
          visit_id: "",
          visit_inpatient_detail_id: 0,
          combination_name: "",
          combination_qty: 0,
          signa_id: 1,
          name: "",
          log: 0,
          note: "",
          details: [
            {
              drug_in_detail_id: null,
              qty: "",
              drug: {
                id: "",
                drug: { name: "" },
              },
              drug_id: "",
            },
          ],
        },
      ],
      dataTreatments: [],
      treatments: [
        {
          visit_id: "",
          visit_inpatient_detail_id: "",
          treatment_id: "",
          log: "0",
          treatment: { name: "" },
        },
      ],
      ref_prognosis: [],
      anamneses: props.patient.anamneses[0] ? props.patient.anamneses[0] : "",
      modalSisroute: false,
      dataSisroute: false,
      imageSisroute: [],
    };
    this.timeout = 0;
    this.PostData = this.PostData.bind(this);
    this.PutData = this.PutData.bind(this);
    this.handlePrognosisChange = this.handlePrognosisChange.bind(this);
    this.postRawatInap = this.postRawatInap.bind(this);
  }

  componentDidMount() {
    this.getContinue();
    this.getSigna();
    this.getPrognosis();
    let drugsMix = [];
    let drugs = [];
    if (this.props.patient.prescribes.length > 0) {
      this.props.patient.prescribes.map((prescribes, y) => {
        if (prescribes.combination_name !== "") {
          drugsMix.push(prescribes);
        } else {
          drugs.push(prescribes);
        }
      });
      this.setState({
        drugs,
        drugsMix,
      });
    }
    if (this.props.patient.treatments[0]) {
      // console.log("yey");
      this.setState({
        treatments: this.props.patient.treatments,
      });
    }
    // console.log(drugs);
  }
  notify(param) {
    Toastify({
      text: param,
      backgroundColor: "linear(to right)",
      className: "info",
    }).showToast();
  }
  //drugs
  onChangeDrugs = (idx) => (evt) => {
    // console.log(evt.target.value);
    const newDrugs = this.state.drugs.map((tr, sidx) => {
      if (idx !== sidx) return tr;
      return {
        visit_id: "",
        visit_inpatient_detail_id: 0,
        combination_name: "",
        combination_qty: 0,
        signa_id: 1,
        log: 0,
        // name: evt.target.value,
        details: [
          {
            drug_in_detail_id: null,
            qty: "",
            drug: {
              id: "",
              name: evt.target.value,
            },
            drug_id: "",
          },
        ],
      };
    });

    this.setState({ drugs: newDrugs });

    const par = evt.target.value;
    // if (evt.target.value.length > 2) {
    //   this.retrieveDataAsynchronouslyDrugs(par);
    // }
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      //search function
      this.retrieveDataAsynchronouslyDrugs(par);
    }, 500);
  };
  getSigna = async (e) => {
    const res = await API.get("management/signa/read");
    if (res.code === 200) {
      this.setState({
        refSigna: res.data,
      });
    }
  };
  cetakRujukan = async (e) => {
    const res = await API.getblob(
      "/registration/print/rujukan?id=" + this.props.patient.id
    );
    if (res) {
      const file = new Blob([res], { type: "application/pdf" });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //print blob
      print(fileURL);
    }
  };

  retrieveDataAsynchronouslyDrugs = async (e) => {
    const res = await API.get("drug/stock/read?keyword=" + e);
    if (res.code === 200) {
      // let first = res.data.filter((dat) => dat.user_approval_id !== null && dat.stock_in.qty - dat.item.stock_out.qty > 0);
      this.setState({
        drugsData: res.data.filter(
          (dat) =>
            dat.user_approval_id !== null &&
            dat.stock_in.qty - dat.stock_out.qty > 0
        ),
      });
    } else {
      console.error("Cannot load data from remote source");
    }
  };
  /**
   * Callback triggered when the autocomplete input changes.
   *
   * @param {Object} val Value returned by the getItemValue function.
   * @return {Nothing} No value is returned
   */
  onSelect(val) {
    this.setState({
      value: val,
    });
    const x = val.split("-", 2);
    console.log("Option from 'database' selected : ", x);
  }

  /**
   * Define the markup of every rendered item of the autocomplete.
   *
   * @param {Object} item Single object from the data that can be shown inside the autocomplete
   * @param {Boolean} isHighlighted declares wheter the item has been highlighted or not.
   * @return {Markup} Component
   */

  getItemValueDrugs(item) {
    // You can obviously only return the Label or the component you need to show
    // In this case we are going to show the value and the label that shows in the input
    // something like "1 - Microsoft"
    return `${item.drug_id}-${item.drug.name}-${item.id}`;
  }

  changeQty = (idx) => (evt) => {
    const val = evt.target.value;

    const drugs = [...this.state.drugs];
    drugs[idx].details[0].qty = val;
    this.setState({ drugs });
    //  console.log(dr);
  };

  changeSigna = (idx) => (evt) => {
    const val = evt.target.value;

    const drugs = [...this.state.drugs];
    drugs[idx].signa_id = val;
    this.setState({ drugs });
    //  console.log(dr);
  };
  handleInputNameChangeDrugs = (idx) => (evt) => {
    const val = evt.split("-", 3);
    const newDrugs = this.state.drugs.map((dr, sidx) => {
      if (idx !== sidx) return dr;
      return {
        visit_id: this.props.patient.id,
        visit_inpatient_detail_id: 0,
        combination_name: "",
        combination_qty: 0,
        signa_id: 1,
        log: 0,
        note: "",
        details: [
          {
            drug_in_detail_id: val[2],
            qty: 10,
            drug: {
              id: val[0],
              name: val[1],
            },
            drug_id: val[0],
          },
        ],
      };
    });
    this.setState({ drugs: newDrugs });
    setTimeout(
      function () {
        let parent = [];
        parent = { data: this.state.drugs, param: "prescribes" };
        this.props.parentCallback(parent);
      }.bind(this),
      200
    );
  };
  handleRemoveInputObat = (idx) => async (evt) => {
    const drugs = [...this.state.drugs];
    let res = await API.delete(
      `/registration/prescribe/delete_mix/` + drugs[idx].id
    );
    if (res.code === 200) {
      drugs[idx].log = 1;
      if (drugs[idx].visit_id !== "") {
        this.setState({ drugs });
      } else {
        this.setState({
          [evt.target.name]: this.state.drugs.filter((s, sidx) => idx !== sidx),
        });
      }
    } else {
      this.setState({
        drugs: this.state.drugs.filter((s, sidx) => idx !== sidx),
      });
    }
  };

  postObat = async (e) => {
    let prescribe = this.state.drugs;
    if (prescribe.length > 0) {
      let res = await API.put(`/registration/prescribe/update`, { prescribe });
      if (res.code === 200) {
        // ALERT("success", "Berhasil Menyimpan Data ");
        this.setState({ drugs: res.data });
        setTimeout(
          function () {
            let parent = [];
            parent = { data: this.state.drugs, param: "prescribes" };
            this.props.parentCallback(parent);
          }.bind(this),
          200
        );
        // console.log(res.data);
      } else {
        // ALERT("error", "gagal menyimpan data");
      }
    }
  };

  //obat end

  // drug mix
  postObatMix = async (e) => {
    let prescribe = this.state.drugsMix;
    if (prescribe.length > 0) {
      let res = await API.put(`/registration/prescribe/update`, { prescribe });
    }
  };
  addDrugsMix = (idx) => (e) => {
    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].details = drugsMix[idx].details.concat([
      {
        drug_in_detail_id: null,
        qty: 10,
        drug: {
          id: "",
          name: "",
        },
        drug_id: "",
      },
    ]);
    this.setState({ drugsMix });
  };
  handleInputNameChangeDrugsMix = (idx, y) => (evt) => {
    let val = evt.split("-", 3);
    // console.log(idx, y, val);
    let drugsMix = [...this.state.drugsMix];
    drugsMix[idx].visit_id = this.props.patient.id;
    drugsMix[idx].details[y].drug.name = val[1];
    drugsMix[idx].details[y].drug_id = val[0];
    drugsMix[idx].details[y].drug_in_detail_id = val[2];

    this.setState({ drugsMix });

    setTimeout(
      function () {
        let parent = [];
        parent = { data: this.state.drugs, param: "prescribes" };
        this.props.parentCallback(parent);
      }.bind(this),
      200
    );
  };

  handleRemoveInputObatMix = (idx) => async (evt) => {
    const drugsMix = [...this.state.drugsMix];
    let res = await API.delete(
      `/registration/prescribe/delete_mix/` + drugsMix[idx].id
    );
    if (res.code === 200) {
      drugsMix[idx].log = 1;
      if (drugsMix[idx].visit_id !== "") {
        this.setState({ drugsMix });
      } else {
        this.setState({
          [evt.target.name]: this.state.drugsMix.filter(
            (s, sidx) => idx !== sidx
          ),
        });
      }
    } else {
      this.setState({
        drugsMix: this.state.drugsMix.filter((s, sidx) => idx !== sidx),
      });
    }
  };
  handleRemoveDrugsMixDetail = (idx, y) => (e) => {
    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].details = drugsMix[idx].details.filter(
      (s, sidx) => y !== sidx
    );
    this.setState({ drugsMix });
  };
  onChangeDrugsMix = (idx, y) => (evt) => {
    // console.log(idx, y, evt.target.value);
    const val = evt.target.value;

    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].details[y].drug.name = val;
    this.setState({ drugsMix });

    const par = evt.target.value;
    // if (evt.target.value.length > 2) {
    //   this.retrieveDataAsynchronouslyDrugs(par);
    // }
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      //search function
      this.retrieveDataAsynchronouslyDrugs(par);
    }, 500);
  };
  changeSignaMix = (idx) => (evt) => {
    const val = evt.target.value;

    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].signa_id = val;
    this.setState({ drugsMix });
    //  console.log(dr);
  };

  changeQtyMix = (idx) => (evt) => {
    const val = evt.target.value;

    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].combination_qty = val;
    this.setState({ drugsMix });
    //  console.log(dr);
  };

  changeQtyMixDetail = (idx, y) => (evt) => {
    const val = evt.target.value;

    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].details[y].qty = val;
    this.setState({ drugsMix });
    //  console.log(dr);
  };

  changeCombinationName = (idx) => (evt) => {
    const val = evt.target.value;

    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].combination_name = val;
    this.setState({ drugsMix });
    //  console.log(dr);
  };
  //drug mix end
  //tindakan
  handleInputNameChangeTreatments = (idx) => (evt) => {
    const val = evt.split("-", 2);
    // console.log(evt.target.value);
    const newTreatments = this.state.treatments.map((tr, sidx) => {
      if (idx !== sidx) return tr;
      return {
        visit_id: this.props.patient.id,
        visit_inpatient_detail_id: "1",
        treatment_id: val[0],
        log: "0",
        treatment: { name: val[1] },
      };
    });

    this.setState({ treatments: newTreatments });
    this.setState({ value: evt });
    setTimeout(
      function () {
        let parent = [];
        parent = { data: this.state.treatments, param: "treatments" };
        this.props.parentCallback(parent);
      }.bind(this),
      200
    );
  };

  postTreatments = async (e) => {
    const treatment = this.state.treatments;
    const res = await API.put("/registration/treatment/update", { treatment });
    // if (res.code === 200) {
    //   // ALERT("success", "Berhasil Menyimpan Data ");
    // } else {
    //   // ALERT("error", "gagal menyimpan data");
    // }
  };
  handleRemoveInputTreatments = (idx) => (evt) => {
    const treatments = [...this.state.treatments];
    treatments[idx].log = 1;
    if (treatments[idx].treatment_id !== "") {
      this.setState({ treatments });
    } else {
      this.setState({
        [evt.target.name]: this.state.treatments.filter(
          (s, sidx) => idx !== sidx
        ),
      });
    }
  };
  retrieveDataAsynchronouslyTreatments = async (e) => {
    // console.log(e);
    let payment_type_id = this.props.patient.payment_type_id;
    let res = await API.get(
      "management/treatments_price/read?payment_type=" +
      payment_type_id +
      "&keyword=" +
      e
    );
    if (res.code === 200) {
      this.setState({
        dataTreatments: res.data,
      });
    } else {
      // console.error("Cannot load data from remote source");
      this.setState({
        dataTreatments: [],
      });
    }
  };
  onChangeTreatments = (idx) => (evt) => {
    const newTreatments = this.state.treatments.map((tr, sidx) => {
      if (idx !== sidx) return tr;
      return {
        visit_id: this.props.patient.id,
        visit_inpatient_detail_id: "1",
        treatment_id: "",
        log: "0",
        treatment: { name: evt.target.value },
      };
    });

    this.setState({ treatments: newTreatments });

    /**
     * Handle the remote request with the current text !
     */
    const par = evt.target.value;
    // if (evt.target.value.length > 2) {
    // setTimeout(event => {
    // this.retrieveDataAsynchronouslyTreatments(par);
    // }, 300);
    // console.log("The Input Text has changed to ", par);
    // }
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      //search function
      this.retrieveDataAsynchronouslyTreatments(par);
    }, 500);
  };
  getItemValueTreatments(item) {
    // You can obviously only return the Label or the component you need to show
    // In this case we are going to show the value and the label that shows in the input
    // something like "1 - Microsoft"
    return `${item.treatment_id}-${item.treatment.name}`;
  }
  //tindakan end
  handleAddInput = (x) => (evt) => {
    this.setState({
      [evt.target.name]: x,
    });
  };
  getContinue = async (e) => {
    const res = await API.get("management/continues/read/1");
    if (res.code === 200) {
      this.setState({
        ref_continue: res.data,
      });
    } else {
      console.error("Cannot load data from remote source");
    }
  };

  getPrognosis = async (e) => {
    const res = await API.get("management/prognosis/read");
    if (res.code === 200) {
      this.setState({
        ref_prognosis: res.data,
      });
    } else {
      console.error("Cannot load data from remote source");
    }
  };

  handleTextChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let advice = this.state.advice;
    let data = [];
    advice[name] = value;
    this.setState({ advice }, () =>
      this.props.parentCallback({ data: this.state.advice, param: "advice" })
    );
    // data = { data: [this.state.advice], param: "advice" };
    // console.log(this.state);
  };
  handlePrognosisChange = (e) => {
    let value = e.target.value;
    let anamneses = [];
    this.setState(
      (prevState) => ({
        anamneses: {
          // object that we want to update
          ...prevState.anamneses, // keep all other key-value pairs
          prognosis_id: value, // update the value of specific key
        },
      }),
      () => {
        anamneses = { data: [this.state.anamneses], param: "anamneses" };
        // console.log(this.state);
        this.props.parentCallback(anamneses);
        this.PutDataAnamneses();
      }
    );
    // this.setState(
    //   {
    //     [e.target.name]: e.target.value,
    //   },
    //   () => {
    //     anamneses = { data: [this.state], param: "anamneses" };
    //     // console.log(this.state);
    //     this.props.parentCallback(anamneses);
    //   }
    // );
  };
  PutDataAnamneses = async () => {
    var param = this.state.anamneses;
    const res = await API.put("management/anamneses/update", param);
  };
  handleSubmit = (e) => {
    if (this.props.patient.diagnoses[0]) {
      if (this.state.advice.id > 0) {
        this.PutData();
      } else {
        this.PostData();
      }
      this.PutVisit();
      this.postObat();
      this.postObatMix();
      // this.PostFhir();
      this.postTreatments();
      if (this.state.continue_id == 3) {
        this.cetakRujukan();
      }
      if (this.state.continue_id == 2) {
        this.postRawatInap();
      }
      // this.PostFhir();
    } else {
      this.notify("ICD HARUS DIISI");
    }
  };
  //postFHIR
  // PostFhir = async () => {
  //   let observation = await API.post(`fhir/observation/${this.props.patient.examinations[0].id}`);
  //   let condition = await API.post(`fhir/condition/${this.props.patient.id}`);
  // }

  PostFhir = async () => {
    for (let index = 0; index < this.props.patient.diagnoses.length; index++) {
      const diag = this.props.patient.diagnoses[index];
      let condition = await API.post(
        `fhir/satu_sehat/condition/single/${this.props.patient.id}/${diag.icd_code}`
      );
    }
    // let condition = await API.post(`fhir/satu_sehat/condition/${this.props.patient.id}`);
    let putEncounter = await API.put(
      `/fhir/satu_sehat/encounterAll/${this.props.patient.id}`
    );
  };
  PutVisit = async () => {
    let userData = JSON.parse(localStorage.getItem("userData"));
    let visit = {
      id: this.state.visit_id,
      continue_id: this.state.continue_id,
      served: 1,
      paramedic_id: userData.id,
      comeback_date: this.state.reVisit.date,
      reminded: this.state.reVisit.notified
    };
    let res = await API.put(`registration/change/visit`, { visit });
    if (res.code === 200) {
      this.postPcare();
      if (this.state.dataSisroute) {
        this.postSisroute();
      }
    }
  };

  hadleRujukan = (e) => {
    if (this.props.patient.diagnoses[0]) {
      let name = e.target.name;
      let value = e.target.value;
      this.setState({
        [name]: value,
      });
      let rujukan = e.target.value;
      // console.log(rujukan);

      if (rujukan === "3") {
        this.setState({
          modalShow: true,
        });
      } else if (rujukan === "6") {
        this.setState({
          modalInternal: true,
        });
      }
    } else {
      this.notify("ICD HARUS DIISI");
    }
  };
  holdSimpan = () => {
    let pr = this.props;
    let th = this;
    confirmedAlert(
      "Info",
      "Apakah anda akan menghapus Melakukan Transaksi lain ? (seperti cetak surat sehat / sakit, dll) ",
      function (confirmed) {
        if (confirmed) {
          pr.getData();
        } else {
          // NO
          setTimeout(() => th.setState({ examFinish: true }), 1000);
        }
      }
    );
  };
  postPcare = async (e) => {
    const res = await API.post("pcare/kunjungan/" + this.props.patient.id);
    // BlobPrint('registration/print/rujukan?id=' + this.props.patient.id)
    if (res) {
      // console.log(res);
      if (res?.metaData?.code === 200 || res?.metaData?.code === 201) {
        if (this.state.continue_id === 3) {
          BlobPrint("registration/print/rujukan?id=" + this.props.patient.id);
        } else {
          // setTimeout(() => this.setState({ examFinish: true }), 1000);
          ALERT("success", "Berhasil Menyimpan Data ");
          setTimeout(() => this.holdSimpan(), 1000);
        }
        let Obat = await API.post(`pcare/obat/` + this.props.patient.id);
        let Tindakan = await API.post(
          `pcare/tindakan/` + this.props.patient.id
        );
        let mcu = await API.post(`pcare/mcu/` + this.props.patient.id);
      } else {
        ALERT("error", "data tersimpan, gagal mengirim ke pcare");
        setTimeout(() => this.holdSimpan(), 1000);
      }
    }
  };

  PostData = async () => {
    var param = this.state.advice;
    let res = await API.post(`registration/advice/create`, param);
  };

  PutData = async () => {
    var param = this.state.advice;
    let res = await API.put(`registration/advice/update`, param);
    if (res.code === 200) {
      setTimeout(() => this.setState({ examFinish: true }), 2000);
      ALERT("success", "Berhasil Menyimpan Data ");
    } else {
      ALERT("error", "gagal menyimpan data");
      // console.log(this.state);
      // if (this.state.continue_id === 3) {
      //   console.log(this.state);

      //   this.setState({ modalPrint: true });
    }
  };

  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({
      [name]: value,
    });
    // console.log(this.state);
  };
  onReload = () => {
    this.props.history.push("/pelayanan");
  };
  //sisroute
  postSisroute = async () => {
    let res = await API.post("/sisrute/referral/post", this.state.dataSisroute);
    if (res?.success) {
      if (this.state.imageSisroute.length > 0) {
        let filex = await getBase64(this.state.imageSisroute[0]);
        let dat = {
          nomor: res.data?.RUJUKAN?.NOMOR,
          jenis: 1,
          file: filex,
          action: "save",
        };
        console.log(filex);
        let postImage = await API.post("/sisrute/referral/image", dat);
      }
    }
  };
  changeSisroute = (val) => {
    this.setState({ dataSisroute: val });
  };

  postRawatInap = async () => {
    let param = {
      nik: this.props.patient.patients.nik,
      name: this.props.patient.patients.name,
      last_name: this.props.patient.patients.last_name,
      sex: this.props.patient.patients.sex,
      parent_name: this.props.patient.patients.parent_name,
      birth_place: this.props.patient.patients.birth_place,
      birth_date: this.props.patient.patients.birth_date,
      address: this.props.patient.patients.address,
      village_id: this.props.patient.patients.village_id,
      education_id: this.props.patient.patients.education_id,
      job_id: this.props.patient.patients.job_id,
      religion_id: this.props.patient.patients.religion_id,
      marital_status_id: this.props.patient.patients.marital_status_id,
      contact: this.props.patient.patients.contact,
      photo: this.props.patient.patients.photo,
      flag: this.props.patient.patients.flag,
      rekam_medis_flags: this.props.patient.patients.rekam_medis_flags,
      parent_id: this.props.patient.parent_id,
      patient_id: this.props.patient.patient_id,
      family_folder: this.props.patient.family_folder,
      family_relationship_id: this.props.patient.family_relationship_id,
      paramedic_id: null,
      // user_id_poli: this.props.patient.user_id_poli,
      payment_type_id: this.props.patient.payment_type_id,
      clinic_id: 10,
      insurance_no: this.props.patient.insurance_no,
      resume: this.props.patient.resume,
      previous_clinic_id: this.props.patient.clinic_id,
      continue_id: 0,
      continue_to: this.props.patient.continue_to,
      continue_internal: null,
      served: false,
      pcare_patient_code_provider:
        this.props.patient.pcare_patient_code_provider,
      admission_type_id: this.props.patient.admission_type_id,
      drug_taken: this.props.patient.drug_taken,
      specialis: this.props.patient.specialis,
      visit_type: this.props.patient.visit_type,
      served_card: this.props.patient.served_card,
      clinic_group: this.props.patient.clinic_group,
      nurse_id: null,
      kd_sadar: this.props.patient.kd_sadar,
      kd_tacc: this.props.patient.kd_tacc,
      pcare_visit_number: null,
      pcare_queue_number: null,
      pcare_treatment_code: 20,
      pcare_sick: 1,
      queue: null,
      statuscall: "0",
      statustracer: "0",
      flg_outdoor: null,
      outdoor_visit_id: null,
      ambulance: "0",
      flg_resume: null,
      drug_queue: null,
      bloodId: this.props.patient.examinations[0].blood_type_id,
    };
    let res = await API.post(`registration/visit`, param);
    if (res.code === 200 || res.code === 201) {
      let par = {
        visit_id: res.data?.visit?.id,
        entry_icd_code: "",
        inpatient_continue_id: null,
        entry_date: moment(new Date()).format("YYYY-MM-DD"),
      };
      let ranap = await API.post("/registration/inpatient/create", par);
    }
  };

  render() {
    if (this.state.examFinish) {
      return <Redirect to="/pelayanan" />;
    }
    var refContinue = this.state.ref_continue.map((con, idx) => {
      return (
        <option key={idx} value={con.id}>
          {con.name}
        </option>
      );
    });
    let modalShow = this.state.modalShow;
    let modalInternal = this.state.modalInternal;
    let modalPrint = this.state.modalPrint;
    let renderRujukan =
      this.state.continue_id === 3 ? (
        <PrintRunjukan
          patient={this.props.patient}
          onHide={() => this.setState({ modalShow: false })}
          ModalShow={() => this.setState({ modalShow: true })}
          cetak={(e) => this.cetakRujukan()}
        />
      ) : (
        ""
      );
    let refSigna = this.state.refSigna.map((sig, idx) => {
      return (
        <option key={idx} value={sig.id}>
          {sig.name}
        </option>
      );
    });
    let DeletedTreatment = [];
    this.state.treatments.map((treatment, idx) => {
      if (treatment.log > 0) {
        DeletedTreatment[idx] = treatment;
      }
    });
    const deletedTreatmentInformation = DeletedTreatment.map((data, key) => {
      return (
        <a key={key} className="dropdown-item">
          {data.treatment.name}
        </a>
      );
    });
    let DeletedDrugs = [];
    this.state.drugs.map((drug, idx) => {
      if (drug.log > 0) {
        DeletedDrugs[idx] = drug;
      }
    });
    let DeletedDrugsMix = [];
    this.state.drugsMix.map((drug, idx) => {
      if (drug.log > 0) {
        DeletedDrugsMix[idx] = drug;
      }
    });
    const deletedDrugsInformation = DeletedDrugs.map((data, key) => {
      return (
        <a key={key} className="dropdown-item">
          {data.details[0] ? data.details[0].drug.name : ""}
        </a>
      );
    });
    const deletedDrugsInformationMix = DeletedDrugsMix.map((data, key) => {
      return (
        <a key={key} className="dropdown-item">
          {data.combination_name}
        </a>
      );
    });
    // console.log(this.props);
    return (
      <>
        <Formik
          enableReinitialize
          initialValues={{
            icd: this.props.patient.diagnoses[0]
              ? this.props.patient.diagnoses[0].icd_code
              : "",
          }}
          validationSchema={SignupSchema}
          onSubmit={(values, { setSubmitting }) => {
            this.handleSubmit();
          }}
        >
          {({ values, errors, touched, isSubmitting }) => (
            <Form>
              {errors.icd && touched.icd ? this.notify(errors.icd) : null}
              <div className="form-group row">
                <div className="col-md-5">
                  <div className="row">
                    <div className="col-md-6">
                      <label
                        htmlFor="example-text-input"
                        className="col-form-label col-form-label-sm"
                      >
                        Tindakan
                      </label>
                    </div>
                    {DeletedTreatment.length > 0 ? (
                      <div>
                        <div className="col-auto">
                          <button
                            type="button"
                            className="btn btn-sm btn-danger mr-0"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            dihapus
                          </button>
                          <div className="dropdown-menu dropdown-menu-left">
                            {deletedTreatmentInformation}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
                <div className="col-md-7">
                  {this.state.treatments.map((tr, idx) => {
                    if (tr.log < 1) {
                      return (
                        <div key={idx} className="form-group row">
                          <Autocomplete
                            inputProps={{
                              className: "form-control form-control-sm",
                              placeholder: "ketikkan minimal 3 huruf tindakan",
                            }}
                            items={this.state.dataTreatments}
                            getItemValue={this.getItemValueTreatments}
                            renderItem={(item, highlighted) => (
                              <div
                                key={item.id}
                                style={{
                                  backgroundColor: highlighted
                                    ? "#eee"
                                    : "transparent",
                                }}
                              >
                                {item.id} - {item.treatment.name} - (
                                {item.price})
                              </div>
                            )}
                            value={this.state.treatments[idx].treatment.name}
                            onChange={this.onChangeTreatments(idx)}
                            onSelect={this.handleInputNameChangeTreatments(idx)}
                            menuStyle={{
                              borderRadius: "3px",
                              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                              background: "rgba(255, 255, 255, 0.9)",
                              padding: "2px 0",
                              fontSize: "90%",
                              position: "fixed",
                              overflow: "auto",
                              zIndex: "100",
                              maxHeight: "110%", // TODO: don't cheat, let it flow to the bottom
                            }}
                            wrapperStyle={{
                              maxWidth: "91.66667%",
                              flex: "0 0 91.66667%",
                              overflow: "auto",
                              maxHeight: '300px'
                            }}
                          />

                          <button
                            className="btn btn-sm btn-danger"
                            style={{ maxWidth: "10%" }}
                            name="treatments"
                            onClick={this.handleRemoveInputTreatments(idx)}
                            type="button"
                          >
                            -
                          </button>
                        </div>
                      );
                    }
                  })}
                  <button
                    type="button"
                    name="treatments"
                    style={{ marginLeft: "2%" }}
                    onClick={this.handleAddInput(
                      this.state.treatments.concat([
                        {
                          visit_id: "",
                          visit_inpatient_detail_id: "",
                          treatment_id: "",
                          log: "0",
                          treatment: { name: "" },
                        },
                      ])
                    )}
                    className="btn btn-sm btn-primary"
                  >
                    Add
                  </button>
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md-5">
                  <div className="row">
                    <div className="col-md-6">
                      <label
                        htmlFor="example-text-input"
                        className=" col-form-label col-form-label-sm"
                      >
                        Obat
                      </label>
                    </div>
                    {DeletedDrugs.length > 0 ? (
                      <div>
                        <div className="col-auto">
                          <button
                            type="button"
                            className="btn btn-sm btn-danger mr-0"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            dihapus
                          </button>
                          <div className="dropdown-menu dropdown-menu-left">
                            {deletedDrugsInformation}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
                <div className="col-md-7">
                  {this.state.drugs.map((drugs, idx) => {
                    if (drugs.log < 1) {
                      return (
                        <div key={idx} className="form-group">
                          <div className="row">
                            <Autocomplete
                              inputProps={{
                                className: "form-control form-control-sm",
                                placeholder: "ketikkan minimal 3 huruf obat",
                              }}
                              items={this.state.drugsData}
                              getItemValue={this.getItemValueDrugs}
                              renderItem={(item, highlighted) => (
                                <div
                                  key={item.id}
                                  style={{
                                    backgroundColor: highlighted
                                      ? "#eee"
                                      : "transparent",
                                  }}
                                >
                                  <div>
                                    {item ? item.id : ""} -{" "}
                                    {item.drug ? item.drug.name : ""}
                                  </div>
                                  <div style={{ color: "red" }}>
                                    stock :{" "}
                                    {item.stock_in.qty - item.stock_out.qty}{" "}
                                  </div>
                                </div>
                              )}
                              value={
                                this.state.drugs[idx].details[0]
                                  ? this.state.drugs[idx].details[0].drug.name
                                  : ""
                              }
                              onChange={this.onChangeDrugs(idx)}
                              onSelect={this.handleInputNameChangeDrugs(idx)}
                              menuStyle={{
                                borderRadius: "3px",
                                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                background: "rgba(255, 255, 255, 0.9)",
                                padding: "2px 0",
                                fontSize: "90%",
                                position: "fixed",
                                overflow: "auto",
                                zIndex: "100",
                                maxHeight: "110%", // TODO: don't cheat, let it flow to the bottom
                              }}
                              wrapperStyle={{
                                maxWidth: "91.66667%",
                                flex: "0 0 91.66667%",
                                overflow: "auto",
                                maxHeight: '300px'
                              }}
                            />
                            <button
                              className="btn btn-sm btn-danger"
                              name="drugs"
                              onClick={this.handleRemoveInputObat(idx)}
                              type="button"
                            >
                              {" "}
                              -
                            </button>
                          </div>
                          <div className="row">
                            <select
                              className="form-control form-control-sm col-md-6"
                              name="signa"
                              dat={idx}
                              onChange={this.changeSigna(idx)}
                              value={drugs.signa_id}
                            >
                              {refSigna}
                            </select>

                            <input
                              className="form-control form-control-sm col-md-4"
                              type="text"
                              placeholder="jumlah"
                              name="Qty"
                              onChange={this.changeQty(idx)}
                              value={
                                drugs.details[0] ? drugs.details[0].qty : ""
                              }
                            />
                          </div>
                        </div>
                      );
                    }
                  })}
                  <button
                    type="button"
                    name="drugs"
                    style={{ marginLeft: "2%" }}
                    onClick={this.handleAddInput(
                      this.state.drugs.concat([
                        {
                          visit_id: "",
                          visit_inpatient_detail_id: 0,
                          combination_name: "",
                          combination_qty: 0,
                          signa_id: 1,
                          log: 0,
                          note: "",
                          details: [
                            {
                              drug_in_detail_id: null,
                              qty: "",
                              drug: {
                                id: "",
                                name: "",
                              },
                            },
                          ],
                        },
                      ])
                    )}
                    className="btn btn-sm btn-primary"
                  >
                    Add
                  </button>
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md-5">
                  <div className="row">
                    <div className="col-md-6">
                      <label
                        htmlFor="example-text-input"
                        className=" col-form-label col-form-label-sm"
                      >
                        Obat Racikan
                      </label>
                    </div>
                    {DeletedDrugsMix.length > 0 ? (
                      <div>
                        <div className="col-auto">
                          <button
                            type="button"
                            className="btn btn-sm btn-danger mr-0"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            dihapus
                          </button>
                          <div className="dropdown-menu dropdown-menu-left">
                            {deletedDrugsInformationMix}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
                <div className="col-md-7">
                  {this.state.drugsMix.map((drugsMix, idx) => {
                    if (drugsMix.log < 1) {
                      return (
                        <div key={idx} className="form-group">
                          <div className="row">
                            <input
                              className="form-control form-control-sm col-md-5 "
                              type="text"
                              placeholder="Nama Obat Racikan"
                              id="example-text-input"
                              name="head"
                              onChange={this.changeCombinationName(idx)}
                              value={this.state.drugsMix[idx].combination_name}
                            />
                            <select
                              className="form-control form-control-sm col-md-3"
                              name="signa"
                              dat={idx}
                              onChange={this.changeSignaMix(idx)}
                              value={this.state.drugsMix[idx].signa_id}
                            >
                              {refSigna}
                            </select>

                            <input
                              className="form-control form-control-sm col-md-2"
                              type="text"
                              placeholder="jumlah"
                              name="Qty"
                              onChange={this.changeQtyMix(idx)}
                              value={this.state.drugsMix[idx].combination_qty}
                            />

                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              name="drugsMix"
                              onClick={this.handleRemoveInputObatMix(idx)}
                            >
                              {" "}
                              -
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-success"
                              name="drugsMix"
                              onClick={this.addDrugsMix(idx)}
                            >
                              {" "}
                              +
                            </button>
                          </div>
                          {drugsMix.details.map((x, y) => {
                            return (
                              <div key={y} className="row">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-warning"
                                  name="drugs"
                                  onClick={this.handleRemoveDrugsMixDetail(
                                    idx,
                                    y
                                  )}
                                >
                                  {" "}
                                  -
                                </button>
                                <Autocomplete
                                  inputProps={{
                                    className: "form-control form-control-sm",
                                    placeholder:
                                      "ketikkan minimal 3 huruf obat",
                                  }}
                                  items={this.state.drugsData}
                                  getItemValue={this.getItemValueDrugs}
                                  renderItem={(item, highlighted) => (
                                    <div
                                      key={item.id}
                                      style={{
                                        backgroundColor: highlighted
                                          ? "#eee"
                                          : "transparent",
                                      }}
                                    >
                                      <div>
                                        {item ? item.id : ""} -{" "}
                                        {item.drug ? item.drug.name : ""}
                                      </div>
                                      <div style={{ color: "red" }}>
                                        stock :{" "}
                                        {item.stock_in.qty - item.stock_out.qty}{" "}
                                      </div>
                                    </div>
                                  )}
                                  value={
                                    this.state.drugsMix[idx].details[y].drug
                                      .name
                                  }
                                  onChange={this.onChangeDrugsMix(idx, y)}
                                  onSelect={this.handleInputNameChangeDrugsMix(
                                    idx,
                                    y
                                  )}
                                  menuStyle={{
                                    borderRadius: "3px",
                                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                    background: "rgba(255, 255, 255, 0.9)",
                                    padding: "2px 0",
                                    fontSize: "90%",
                                    position: "fixed",
                                    overflow: "auto",
                                    zIndex: "100",
                                    maxHeight: "110%", // TODO: don't cheat, let it flow to the bottom
                                  }}
                                  wrapperStyle={{
                                    maxWidth: "65%",
                                    flex: "0 0 91.66667%",
                                    overflow: "auto",
                                    maxHeight: '300px'
                                  }}
                                />

                                <input
                                  className="form-control form-control-sm col-md-2"
                                  type="text"
                                  placeholder="jumlah"
                                  name="Qty"
                                  onChange={this.changeQtyMixDetail(idx, y)}
                                  value={
                                    this.state.drugsMix[idx].details[y].qty
                                  }
                                />
                              </div>
                            );
                          })}
                        </div>
                      );
                    }
                  })}
                  <button
                    type="button"
                    name="drugsMix"
                    style={{ marginLeft: "2%" }}
                    onClick={this.handleAddInput(
                      this.state.drugsMix.concat([
                        {
                          visit_id: "",
                          visit_inpatient_detail_id: 0,
                          combination_name: "",
                          combination_qty: 0,
                          signa_id: 1,
                          note: "",
                          log: false,
                          details: [
                            {
                              drug_in_detail_id: null,
                              qty: "",
                              drug: {
                                id: "",
                                name: "",
                              },
                            },
                          ],
                        },
                      ])
                    )}
                    className="btn btn-sm btn-primary"
                  >
                    Add
                  </button>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Advice
                </label>
                <div className="col-md-7">
                  <div className="row">
                    <h4>Individu</h4>
                    <textarea
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="saran untuk individu"
                      id="example-text-input"
                      name="advice"
                      onChange={this.handleTextChange}
                      value={this.state.advice.advice}
                    />
                    <h4>Keluarga</h4>
                    <textarea
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="saran untuk keluarga"
                      id="example-text-input"
                      name="advice_family"
                      onChange={this.handleTextChange}
                      value={this.state.advice.advice_family ?? ''}
                    />
                    <h4>Komunitas</h4>
                    <textarea
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="saran untuk Komunitas"
                      id="example-text-input"
                      name="advice_community"
                      onChange={this.handleTextChange}
                      value={this.state.advice.advice_community ?? ''}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Evaluasi
                </label>
                <div className="col-md-7">
                  <div className="row">
                    <textarea
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="evalusai pasien"
                      id="example-text-input"
                      name="evaluation"
                      onChange={this.handleTextChange}
                      value={this.state.advice.evaluation}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Prognosis
                </label>
                <div className="col-md-7">
                  <div className="row">
                    <select
                      className="form-control form-control-sm"
                      id="prognosis_id"
                      name="prognosis_id"
                      value={this.state.anamneses.prognosis_id}
                      onChange={this.handlePrognosisChange}
                    >
                      {this.state.ref_prognosis.map((d, k) => (
                        <option value={d.id} key={k}>
                          {d.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Tindak Lanjut
                </label>
                <div className="col-md-7">
                  <div className="row">
                    <select
                      className="form-control form-control-sm"
                      id="example-text-input"
                      name="continue_id"
                      value={this.state.continue_id}
                      onChange={this.hadleRujukan}
                    >
                      {refContinue}
                    </select>
                  </div>
                </div>
              </div>
              {renderRujukan}
              {this.state.modalSisroute ? (
                <Sisroute
                  patient={this.props.patient}
                  onHide={() => this.setState({ modalSisroute: false })}
                  show={this.state.modalSisroute}
                  change={(e) => this.changeSisroute(e)}
                  image={{
                    change: (e) => this.setState({ imageSisroute: e }),
                    data: this.state.imageSisroute,
                  }}
                />
              ) : (
                ""
              )}
              <button
                className="btn btn-primary"
                disabled={isSubmitting}
                type="submit"
              >
                Simpan
              </button>
              <button
                className="btn btn-danger"
                type="button"
                onClick={this.onReload}
              >
                Tutup
              </button>
              {modalShow ? (
                <Modal
                  show={modalShow}
                  onHide={() => this.setState({ modalShow: false })}
                  sisroute={() => this.setState({ modalSisroute: true })}
                  patient={this.props.patient}
                />
              ) : (
                ""
              )}

              {modalInternal ? (
                <ModalInternal
                  show={modalInternal}
                  onHide={() => this.setState({ modalInternal: false })}
                  patient={this.props.patient}
                  handleSubmit={this.handleSubmit}
                />
              ) : (
                ""
              )}

              {/* {modalPrint ? (
                <PrintModal
                  alert={() => ALERT("success", "Berhasil Menyimpan Data ")}
                  closed={() =>
                    setTimeout(() => this.setState({ examFinish: true }), 1000)
                  }
                  show={modalPrint}
                  patient={this.props.patient}
                  onHide={() => this.setState({ modalPrint: false })}
                  ModalShow={() => this.setState({ modalPrint: true })}
                />
              ) : (
                ""
              )} */}
            </Form>
          )}
        </Formik>
      </>
    );
  }
}

export default Planning;
